// @ts-check

const listenersByType = new Map();

function normalizeType(type) {
  return String(type || '').trim();
}

/**
 * Registriert einen Listener fuer fachliche Core-Events wie object:moved.
 * @param {string} type
 * @param {(event:any) => void} listener
 * @returns {() => void}
 */
export function on(type, listener) {
  const eventType = normalizeType(type);
  if (!eventType || typeof listener !== 'function') return () => undefined;
  if (!listenersByType.has(eventType)) listenersByType.set(eventType, new Set());
  listenersByType.get(eventType).add(listener);
  return () => off(eventType, listener);
}

export function off(type, listener) {
  const eventType = normalizeType(type);
  const listeners = listenersByType.get(eventType);
  if (!listeners) return false;
  const removed = listeners.delete(listener);
  if (!listeners.size) listenersByType.delete(eventType);
  return removed;
}

export function emit(type, detail = {}) {
  const eventType = normalizeType(type);
  if (!eventType) return null;
  const event = {
    type: eventType,
    detail: detail && typeof detail === 'object' ? detail : {},
    timestamp: Date.now()
  };
  for (const listener of [...(listenersByType.get(eventType) || [])]) {
    try {
      listener(event);
    } catch (error) {
      console.warn(`KS Studio Event-Listener fehlgeschlagen: ${eventType}`, error);
    }
  }
  return event;
}

export function clearEventListeners(type = null) {
  const eventType = normalizeType(type);
  if (eventType) {
    listenersByType.delete(eventType);
    return;
  }
  listenersByType.clear();
}
